import { useCallback, useEffect, useState } from "react";

import { toError, type AsyncState } from "@/application/hooks/async-state";
import type { Vehicle } from "@/domain/models/vehicle";
import { repositories } from "@/infrastructure/repositories";

export function useVehicle(id: string | undefined) {
  const isNew = !id || id === "new";
  const [state, setState] = useState<AsyncState<Vehicle | null>>({
    status: isNew ? "success" : "loading",
    data: isNew ? null : null,
    error: null,
  });

  const reload = useCallback(async () => {
    if (isNew || !id) {
      setState({ status: "success", data: null, error: null });
      return;
    }

    setState({ status: "loading", data: null, error: null });
    try {
      const data = await repositories.vehicles.getById(id);
      if (!data) {
        setState({ status: "empty", data: null, error: null });
        return;
      }
      setState({ status: "success", data, error: null });
    } catch (error) {
      setState({ status: "error", data: null, error: toError(error) });
    }
  }, [id, isNew]);

  useEffect(() => {
    void reload();
  }, [reload]);

  return { ...state, isNew, reload };
}
